import { Component } from '@angular/core';

@Component({
  selector: 'app-email-loader',
  templateUrl: './email-loader.component.html',
  styleUrls: ['./email-loader.component.scss'],
  standalone: false
})
export class EmailLoaderComponent {

}

